<template>
  <div class="auth-shell">
    <div class="auth-glow auth-glow--left"></div>
    <div class="auth-glow auth-glow--right"></div>

    <v-container fluid class="auth-frame pa-4 pa-md-8">
      <v-row class="auth-stage ma-0" align="center" justify="center">
        <v-col cols="12" md="10" lg="8" xl="7" class="auth-column pa-0">
          <v-card class="auth-card" elevation="16">
            <div class="auth-grid">

              <!-- Panel izquierdo (solo desktop) -->
              <aside class="brand-panel d-none d-md-flex">
                <div class="brand-wrap">
                  <v-img src="../assets/logoWhite.png" contain class="brand-logo" />
                  <div class="brand-copy text-center">
                    Plataforma de monitorización y control de riego inteligente.
                  </div>
                </div>
              </aside>

              <!-- Panel derecho: formulario -->
              <section class="form-panel">
                <!-- Header móvil -->
                <div class="mobile-header d-flex d-md-none align-center mb-6">
                  <v-img src="../assets/logoWhite.png" contain class="mobile-logo" />
                  <div class="ml-3">
                    <div class="mobile-title">SmartWater</div>
                    <div class="mobile-subtitle">Plataforma de monitorización y control de riego inteligente</div>
                  </div>
                </div>

                <div class="form-header">
                  <div class="form-title">Bienvenido/a</div>
                  <p class="form-subtitle">Introduzca sus credenciales</p>
                </div>

                <v-form ref="form" class="mt-6" @submit.prevent="submitLogin">
                  <v-text-field v-model="email" label="Usuario" outlined dense prepend-inner-icon="mdi-account-outline"
                    autocomplete="username" :error="inputError" :disabled="loading" class="mb-4"
                    color="teal darken-2" />

                  <v-text-field v-model="password" label="Contraseña" outlined dense
                    prepend-inner-icon="mdi-lock-outline" :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" @click:append="showPassword = !showPassword"
                    autocomplete="current-password" :error="inputError" :disabled="loading" color="teal darken-2" />

                  <div class="d-flex justify-start mt-n2">
                    <a href="#/olvide-password" class="forgot-link" @click.prevent="$router.push({ name: 'OlvidePassword' })">
                      <v-icon size="16" class="mr-1">mdi-lock-question</v-icon>He olvidado la contraseña
                    </a>
                  </div>

                  <transition name="expand">
                    <div v-if="inputError" class="error-box mt-4">
                      <v-icon size="18" class="mr-2" color="error">mdi-alert-circle-outline</v-icon>
                      <span>Las credenciales no son válidas. Revisa email y contraseña.</span>
                    </div>
                  </transition>

                  <v-btn class="login-btn mt-6" block large type="submit" :disabled="!email || !password || loading"
                    depressed>
                    <v-progress-circular v-if="loading" indeterminate size="18" width="2" class="mr-2" color="white" />
                    Iniciar sesión
                  </v-btn>

                  <div class="form-note">
                    Si necesita ayuda, contacte con soporte técnico.
                  </div>
                </v-form>
              </section>

            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import bg_image from "@/assets/bg_user_demo.png";

export default {
  name: "LoginComponent",
  data() {
    const dataFincas = [
      { id: 10, nombre: "Finca Uno", dispositivos: "B827EB7BE480, B827EB7BE482" },
      { id: 11, nombre: "Finca Dos", dispositivos: "B827EB7BE481, B827EB7BE483" },
    ];
    return {
      email: "",
      password: "",
      showPassword: false,
      inputError: false,
      loading: false,
      dataFincas,
    };
  },
  methods: {
    submitLogin() {
      this.inputError = false;
      this.loading = true;

      axios.post(`${process.env.VUE_APP_API_URL}/login`, {
        email: this.email,
        password: this.password,
      })
      .then((response) => {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("id", 1);
        localStorage.setItem("email", this.email);
        localStorage.setItem("nombre", "ECO");
        localStorage.setItem("apellido", "Engineering");
        localStorage.setItem("URL_avatar", bg_image);
        localStorage.setItem("fincas", JSON.stringify(this.dataFincas));
        localStorage.setItem("usuario", btoa(1));
        localStorage.setItem("dispositivos", this.dataFincas[0].dispositivos.replace(/\s/g, ""));
        this.$router.push("/Panel");
      })
      .catch(() => {
        this.inputError = true;
      })
      .finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped>
.auth-shell {
  position: fixed;
  inset: 0;
  z-index: 200;
  overflow: hidden;
}

.auth-glow {
  position: absolute;
  border-radius: 999px;
  filter: blur(24px);
  opacity: 0.55;
  pointer-events: none;
}

.auth-glow--left {
  top: 70px;
  left: -80px;
  width: 220px;
  height: 220px;
  background: rgba(0, 121, 107, 0.2);
}

.auth-glow--right {
  right: -110px;
  bottom: 40px;
  width: 260px;
  height: 260px;
  background: rgba(13, 148, 136, 0.16);
}

.auth-frame {
  min-height: 100vh;
  background: #f6f7fb;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-stage {
  width: 100%;
  min-height: calc(100vh - 32px);
  align-items: center;
  justify-content: center;
}

.auth-column {
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-card {
  position: relative;
  width: 100%;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.06) !important;
  background: rgba(255, 255, 255, 0.88) !important;
  border-radius: 16px !important;
}

.auth-grid {
  display: grid;
  grid-template-columns: 1fr;
  min-height: 585px;
}

@media (min-width: 960px) {
  .auth-grid {
    grid-template-columns: 42% 58%;
    min-height: 525px;
  }
}

.brand-panel {
  background: linear-gradient(135deg, #003830, #004d40);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px;
}

.brand-wrap {
  position: relative;
  z-index: 1;
  max-width: 250px;
  width: 100%;
  margin: 0 auto;
  color: white;
  text-align: center;
}

.brand-logo {
  display: block;
  max-width: 230px;
  height: 152px;
  margin: 34px auto 0;
  filter: drop-shadow(0 14px 28px rgba(0, 0, 0, 0.22));
}

.brand-copy {
  font-size: 12px;
  opacity: 0.85;
  color: white;
}

.form-panel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 26px 22px;
  background: rgba(255, 255, 255, 0.96);
}

@media (min-width: 960px) {
  .form-panel {
    padding: 42px 42px;
  }
}

.mobile-header {
  padding: 16px 18px;
  border-radius: 22px;
  background: linear-gradient(145deg, rgba(0, 63, 54, 0.94), rgba(0, 115, 98, 0.9));
  color: white;
}

.mobile-logo {
  width: 118px;
  height: 38px;
  flex: 0 0 auto;
}

.mobile-title {
  font-size: 16px;
  font-weight: 800;
  color: white;
}

.mobile-subtitle {
  margin-top: 2px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.78);
}

.form-title {
  font-size: 24px;
  font-weight: 900;
}

.form-subtitle {
  margin: 12px 0 0;
  color: rgba(15, 23, 42, 0.62);
  font-size: 14px;
  line-height: 1.65;
}

.error-box {
  display: flex;
  align-items: center;
  border-radius: 14px;
  padding: 12px 14px;
  font-size: 12px;
  color: #b42318;
  background: rgba(180, 35, 24, 0.08);
  border: 1px solid rgba(180, 35, 24, 0.18);
}

.login-btn {
  min-height: 50px !important;
  border-radius: 16px !important;
  text-transform: none !important;
  font-size: 15px !important;
  font-weight: 800 !important;
  letter-spacing: 0.01em !important;
  background: linear-gradient(135deg, #00594d, #004d40) !important;
  color: white !important;
  box-shadow: 0 16px 34px rgba(0, 77, 64, 0.2) !important;
}

.forgot-link {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  color: rgba(15, 23, 42, 0.55);
  text-decoration: none;
}

.forgot-link:hover {
  color: #00796b;
}

.form-note {
  margin-top: 18px;
  font-size: 12px;
  text-align: center;
  color: rgba(15, 23, 42, 0.46);
  display: flex;
  align-items: center;
  justify-content: center;
}

.expand-enter-active,
.expand-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.expand-enter,
.expand-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>

<style>
.auth-shell input:-webkit-autofill {
  box-shadow: 0 0 0 1000px rgba(255, 255, 255, 0.95) inset !important;
  -webkit-box-shadow: 0 0 0 1000px rgba(255, 255, 255, 0.95) inset !important;
  -webkit-text-fill-color: rgba(15, 23, 42, 0.88) !important;
}
</style>
